import React from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import queryString from 'query-string'
import moment from 'moment'
import './Players.css'
import { Schemas } from '../../middleware/api'
import { connectPagination } from '../../decorators'
import { loadPlayers, bindKeywordArguments } from '../../actions'
import get from 'lodash/get'

import { Table, filterCellRenderer/*, percentCellRenderer */ } from '../Generic'
import { Column } from '@rapiddot/react-virtual-list'
import { getPlayerPath /*, formatMoney */, getSort } from '../../util'
import Search from '../Search'

class PlayersList extends React.Component {

  _renderRating({rowData, index}) {
    if(!rowData.properties) {
      return '-'
    }

    if(rowData.properties.manual_rating > 0) {
      return `${rowData.properties.manual_rating} (manual)`
    } else {
      return `${rowData.properties.automatic_rating} (auto)`
    }
  }

  _handleSearch = (queryObj) => {
    const query = queryString.stringify(queryObj)
    browserHistory.push([location.pathname, query].join('?'))
  }

  render() {
    const { pagination, totalItems, location, searchSuggestions } = this.props

    return (
      <div className="players-table-wrapper">
        <Search 
          onSearch={this._handleSearch}
          searchSuggestions={searchSuggestions}
          query={get(location, "query")}
        />

        { !totalItems && get(pagination, 'isFetching')  && <div className="table-info-header">Loading Players...</div> }
        { this.props.title && <div className="table-title">{this.props.title}</div>}        

        { this.props.totalItems > 0 && <div className="table-info-header">showing {this.props.totalItems} players...</div> }

        <Table {...this.props} rowHeight={40} className="generic-table">
          <Column
            label='id'
            dataKey='id'
            cellRenderer={({rowData}) => <Link to={`${getPlayerPath(rowData)}/analytics`}>{rowData.id}</Link>}
            className='small-table-column'
          />

          <Column
            label='gender'
            dataKey='gender'
            sortable={true}
            cellRenderer={({rowData}) => get(rowData, 'gender') || '-'}
            className='generic-table-column'
          />

          <Column
            label='age'
            dataKey='birthday'
            sortable={true}
            cellRenderer={({rowData}) => moment().diff(moment(rowData.birthday), 'years')}
            className='generic-table-column'
          />

          <Column
            label='registration date'
            dataKey='registration_date'
            sortable={true}
            cellRenderer={({rowData}) => moment(rowData.registration_date).format('DD/MM/YYYY')}
            className='generic-table-column'
          />

          <Column
            label='last bet date'
            dataKey='properties.last_bet_date'
            sortable={true}
            cellRenderer={({rowData}) => moment(get(rowData, 'properties.last_bet_date')).format('DD/MM/YYYY')}
            className='generic-table-column'
          />

          <Column
            label='country'
            dataKey='country'
            sortable={true}
            className='generic-table-column'
            cellRenderer={bindKeywordArguments(filterCellRenderer, {location, filter: 'country'})}
          />

          <Column
            label='city'
            dataKey='city'
            sortable={true}
            className='generic-table-column'
            cellRenderer={bindKeywordArguments(filterCellRenderer, {location, filter: 'city'})}
          />

          <Column
            label='rating'
            dataKey='properties.automatic_rating'
            sortable={true}
            cellRenderer={this._renderRating}
            className='generic-table-column'
          />

           {/* <Column
            label='total stake'
            dataKey='stakeTotal'
            sortable={true}
            cellRenderer={({rowData}) => (
              <div>
                <div>{formatMoney(rowData.stakeTotal)}</div>
                <div className="generic-table-column__subtitle">
                  {formatMoney(rowData.stakeMean)} avg
                </div>
              </div>
            )}
            className='generic-table-column'
          />

          <Column
            label='total prize'
            dataKey='prizeTotal'
            sortable={true}
            cellRenderer={({rowData}) => (
              <div>
                <div>{formatMoney(rowData.prizeTotal)}</div>
                <div className="generic-table-column__subtitle">
                  {formatMoney(rowData.prizeMean)} avg
                </div>
              </div>
            )}
            className='generic-table-column'
          />

          <Column
            label='total profits'
            dataKey='profits'
            sortable={true}
            cellRenderer={({rowData}) => (
              <div>
                <div className={rowData.profits > 0 ? 'money-column--positive' : 'money-column--negative'}>
                  {formatMoney(rowData.profits)}
                </div>
                <div className="generic-table-column__subtitle">
                  {formatMoney(rowData.profits / rowData.ticketsTotal)} avg
                </div>
              </div>
            )}
            className='generic-table-column'
          />

          <Column
            label='total tickets'
            dataKey='ticketsTotal'
            sortable={true}
            className='generic-table-column'
          />

          <Column
            label='top 5 recall'
            dataKey='recall5'
            sortable={true}
            cellRenderer={ percentCellRenderer }
            className='generic-table-column'
          />*/}
        </Table>
      </div>
    )
  }
}

const fields = [
  'id', 
  'gender', 
  'birthday', 
  'registration_date',
  'country',
  'city',
  'properties',
  'stats',
]
const withPagination = connectPagination({
  entitykey: 'players',
  loadItems: loadPlayers,
  itemSchema: Schemas.PLAYER,
  getQueryParams: ({state, ownProps}) => {
    return {
      ordering: '-profits',
      fields: fields.join(','),
      ...get(state,"routing.locationBeforeTransitions.query")
    }
  },
  title: 'Players Pagination',
})(PlayersList)

export const Players = connect(
  (state, ownProps) => ({
    streamId: ownProps.params.id, 
    location: ownProps.location,
    ...getSort(get(ownProps, 'location.query.ordering', '-profits')),
    searchSuggestions: get(state, "ui.searchSuggestions.players"),
  }),
  { loadPlayers }
)(withPagination)


// WEBPACK FOOTER //
// ./src/components/Players/Players.js